/**
 * User: herbert
 * Date: 20.02.16
 * Time: 21:44
 */

import Reflux from 'reflux';

import optionActions from '../actions/option-actions.js';
import stepActions from '../../slxstep/actions/step-actions.js';

export default Reflux.createStore({
	init: function() {
		this.listenToMany(optionActions);
		this.listenToMany(stepActions);
		this.state = {options: null};
	},
	onSet: function(options) {
		this.state.options = options;
		this.state.spotA = options?options.paramSpot:false; // default-wert
		this.state.spotB = false;
		this.output();
	},
	onSetSpot: function(a, b) {
		this.state.spotA = a;
		this.state.spotB = b;
		this.output();
	},
	onClear: function() {
		this.state.options = null;
		this.state.spotA = false;
		this.state.spotB = false;
		this.output();
	},
	// stepActions
	onNext: function() {
		this.onClear();
	},
	onPrev: function() {
		this.onClear();
	},
	// output
	output: function() {
		this.trigger(this.getInitialState());
	},
	getInitialState: function() {
		return {options: this.state.options, spotA: this.state.spotA, spotB: this.state.spotB};
	}
});
